module.exports = __webpack_public_path__ + "static/media/unique.901b8c72.png";